import { render, staticRenderFns } from "./GetQuotesBox.vue?vue&type=template&id=5a08e127&"
import script from "./GetQuotesBox.vue?vue&type=script&lang=js&"
export * from "./GetQuotesBox.vue?vue&type=script&lang=js&"
import style0 from "./GetQuotesBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports